/* modules imports */
import styled, { keyframes } from "styled-components";

/* project files imports */
import { devices } from "constants/style";
import Button from "components/Button";

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;

  @media ${devices.sm} { row-gap: 25px; }
  @media ${devices.lg} { row-gap: 35px; }
`;

const fadeIn = keyframes`
  100% { opacity: 1; }
`;

export const Text = styled.span`
  max-width: 275px;
  font-size: 16px;
  text-align: center;
  opacity: 0;
  animation: ${fadeIn} .15s forwards;
  animation-delay: .15s;

  @media ${devices.sm} {
    max-width: 450px;
    font-size: 18px;
  }

  @media ${devices.lg} {
    max-width: 600px;
    font-size: 20px;
  }
`;

export const BoldText = styled(Text)`
  font-family: var(--font-content-bold);
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  opacity: 0;
  animation: ${fadeIn} .15s forwards;
  animation-delay: .15s;

  @media ${devices.sm} { column-gap: 20px; }
  @media ${devices.lg} { column-gap: 35px; }
`;

export const ButtonWrapper = styled(Button)`
  opacity: 0;
  animation: ${fadeIn} .15s forwards;
  animation-delay: .15s;
`;

export const ButtonText = styled.span`
  font-size: 22px;
  font-family: var(--font-content-bold);
`;

export const RefreshUserDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 16px;
  row-gap: 8px;
  padding: 0 10px;

  @media ${devices.sm} {
    font-size: 18px;
    row-gap: 10px;
  }
`;

export const RefreshUserData = styled.span`
  font-size: 16px;
  cursor: pointer;

  @media ${devices.sm} { font-size: 18px; }

  &:hover {
    text-decoration: underline; 
  }
`;
